export default __webpack_public_path__ + "static/media/Services1.3b0abf06.jpg";